import { InjectionToken } from '@angular/core';
import { HxDialogRef } from '../dialog-ref';

/**
 * Injection token for passing data to dialog component
 *
 * @example
 *   constructor(@Inject(DIALOG_DATA) public data: MyDataType) {}
 */
export const DIALOG_DATA = new InjectionToken<any>('HxDialogData');

/**
 * Injection token for accessing dialog reference inside dialog component
 *
 * @example
 *   constructor(@Inject(DIALOG_REF) public dialogRef: HxDialogRef) {}
 */
export const DIALOG_REF = new InjectionToken<HxDialogRef>('HxDialogRef');
